// API Configuration
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://basreliefatlas-production.up.railway.app';

export const API_ENDPOINTS = {
  reliefs: `${API_BASE_URL}/api/reliefs`,
  search: `${API_BASE_URL}/api/search`,
  test: `${API_BASE_URL}/api/test`,
  submit: `${API_BASE_URL}/api/reliefs/submit`,
  submissions: `${API_BASE_URL}/api/reliefs/submissions`,
};

export default API_BASE_URL; 